import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { take, switchMap } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { LenderOrganizationsService } from 'src/app/services/lender.organizations.service';
import { ORGANIZATION_ID_CLAIM } from 'src/app/models/user/user.model';

@Component({
  selector: 'app-lender-organization-route-resolver',
  template: '',
  standalone: true
})
export class LenderOrganizationRouteResolverComponent implements OnInit {
  
  constructor(
    private router: Router,
    private authService: AuthenticationService,
    private lenderOrgService: LenderOrganizationsService
  ) {}

  ngOnInit(): void {
    this.authService.user$.pipe(
      take(1),
      switchMap(user => {
        const organizationId = user?.[ORGANIZATION_ID_CLAIM];
        
        if (!organizationId) {
          this.router.navigate(['/lender/dashboard'], { replaceUrl: true });
          return [];
        }

        return this.lenderOrgService.isParentOrganization(organizationId);
      })
    ).subscribe(isParent => {
      setTimeout(() => {
        if (isParent) {
          this.router.navigate(['/lender/lender-organization-list'], { replaceUrl: true });
        } else {
          this.router.navigate(['/lender/lender-organization/products'], { replaceUrl: true });
        }
      }, 0);
    });
  }
}